import * as React from 'react';

import { Page } from '../../components/Page';
import { AboutCompanyContainer } from '../AboutCompanyContainer';
import { DocumentsContainer } from '../DocumentsContainer';
import { ContactsContainer } from '../ContactsContainer';
import { FeedbackContainer } from '../FeedbackContainer';
import { HeadContainer } from '../HeadContainer';
import { OfficesContainer } from '../OfficesContainer';
import { ProjectsContainer } from '../ProjectsContainer';
import { HousesContainer } from '../HousesContainer';
import { VideosContainer } from '../VideosContainer';
import { OpenVillageBannerContainer } from '../OpenVillageBannerContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { Responsive } from '@cian/ui-kit';
import { BuilderReviewsContainer } from '../BuilderReviewsContainer';
import { AccreditationBanksContainer } from '../AccreditationBanksContainer';
import { ReliableBlockContainer } from '../ReliableBlockContainer';
import { EscrowBlockContainer } from '../EscrowBlockContainer';
import { PromotionsContainer } from '../PromotionsContainer';

export const PageContainer = () => {
  return (
    <>
      <Page>
        <HeadContainer />
        <OpenVillageBannerContainer />
        <PromotionsContainer />
        <AboutCompanyContainer />
        <ReliableBlockContainer />
        <ProjectsContainer />
        <OfficesContainer />
        <AccreditationBanksContainer />
        <EscrowBlockContainer />
        <HousesContainer />
        <VideosContainer />
        <BuilderReviewsContainer />
        <DocumentsContainer />
        <ContactsContainer />
        <FeedbackContainer />
      </Page>
      <Responsive phone>
        <BreadcrumbsContainer placement="footer" />
      </Responsive>
    </>
  );
};
